import { Component, OnDestroy } from '@angular/core'
import { RoutingService, TranslationService } from '@spartacus/core'
import { Order, OrderHistoryList } from '@spartacus/order/root'
import { combineLatest, Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { orderHistoryPageSize } from '../../shared/mb-constants'
import { MbOrderType } from '../../models'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-history',
  templateUrl: './mb-order-history.component.html',
  styleUrls: ['./mb-order-history.component.scss'],
})
export class MbOrderHistoryComponent implements OnDestroy {

  orderHistoryPageSize = orderHistoryPageSize
  orderType = MbOrderType
  sortType: string = ''
  isLoaded$ = this.userOrderService.getOrderHistoryListLoaded()
  orders$ = this.userOrderService.getOrderHistoryList(this.orderHistoryPageSize).pipe(
    tap((orders: OrderHistoryList | undefined) => {
      if (orders?.pagination?.sort) {
        this.sortType = orders.pagination.sort
      }
    })
  )

  constructor (protected routing: RoutingService,
               protected userOrderService: OrderHistoryService,
               protected translation: TranslationService) {
  }

  ngOnDestroy (): void {
    this.userOrderService.clearOrderList()
  }

  changeSortCode (sortCode: string): void {
    const event: { sortCode: string; currentPage: number } = {
      sortCode,
      currentPage: 0,
    }
    this.sortType = sortCode
    this.fetchOrders(event)
  }

  pageChange (page: number): void {
    const event: { sortCode: string; currentPage: number } = {
      sortCode: this.sortType,
      currentPage: page,
    }
    this.fetchOrders(event)
  }

  goToOrderDetail (order: Order) {
    return this.routing.go({
      cxRoute: 'mbOrderDetails',
      params: order,
    })
  }

  getSortLabels (): Observable<{ byDate: string; byOrderNumber: string }> {
    return combineLatest([
      this.translation.translate('sorting.date'),
      this.translation.translate('sorting.orderNumber'),
    ]).pipe(
      map(([textByDate, textByOrderNumber]) => ({
          byDate: textByDate,
          byOrderNumber: textByOrderNumber,
        }))
    )
  }

  private fetchOrders (event: { sortCode: string; currentPage: number }): void {
    this.userOrderService.loadOrderList(
      this.orderHistoryPageSize,
      event.currentPage,
      event.sortCode
    )
  }
}
